import React from 'react';

const TableSkeleton = ({primary=5, secondary=7}) => {
  return (
    <tbody style={styles.tbody}>
      {[...Array(primary)].map((_, index) => (
        <tr key={index} style={styles.tr}>
          {[...Array(secondary)].map((_, cellIndex) => (
            <td key={cellIndex} style={styles.td}>
              <div style={styles.skeleton}></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

const styles = {
  tbody: {
    width: '100%',
  },
  tr: {
    backgroundColor: '#ffffff',
  },
  td: {
    padding: '12px 15px',
  },
  skeleton: {
    height: '20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    animation: 'pulse 1.5s ease-in-out infinite',
    '@keyframes pulse': {
      '0%': {
        opacity: 0.6,
      },
      '50%': {
        opacity: 0.3,
      },
      '100%': {
        opacity: 0.6,
      }
    }
  }
};

export default TableSkeleton;